import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {Link} from 'react-router';

import RaceVideoPlayer from 'modules/HorseRacing/components/RaceVideoPlayer';
import HorseRacingFormTable from 'modules/HorseRacing/components/HorseRacingFormTable';
import HorseRacingLastRun from 'modules/HorseRacing/components/HorseRacingLastRun';
import HorseRacingInsightsList from 'modules/HorseRacing/containers/HorseRacingInsightsList';

import Silk from 'modules/Common/components/Silk';

import CaretIcon from 'modules/Common/components/svg/CaretIcon';
import PlayIcon from 'modules/Common/components/svg/PlayIcon';
import BetLink from 'modules/Common/containers/BetLink';

import {formatHeadgear, keepUpperCase} from 'modules/HorseRacing/utils';
import {localTimeShort} from 'utils/LocalDateTimeHelper';
import { isMobile } from 'react-device-detect';

import _ from 'lodash';

require("./HorseRacingRacecardRunner.scss");

export default class HorseRacingRacecardRunner extends Component {
  static propTypes = {
    raceSummary: PropTypes.shape({
      date: PropTypes.string,
      time: PropTypes.string,
      course_name: PropTypes.string
    }),
    runner: PropTypes.object,
    eventRef: PropTypes.string,
    showExpandedForm: PropTypes.bool,
    toggleFormExpanded: PropTypes.func.isRequired,
    eachWay: PropTypes.object,
    suspended: PropTypes.bool,
    fixture: PropTypes.string,
    embedded: PropTypes.bool,
    dispatch: PropTypes.func,
    key: PropTypes.string
  }

  constructor(props) {
    super(props);

    this.state = {
      formExpanded: this.props.showExpandedForm || false,
      expandedTarget: null
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.showExpandedForm !== this.props.showExpandedForm) {
      this.setState({formExpanded: newProps.showExpandedForm});
    }
  }

  hasFormList() {
    const {runner: {horse: {previous_results: {length} = {}} = {}} = {}} = this.props;
    return !!length;
  }

  getLastRun() {
    const {runner: {horse: {previous_results = {}} = {}} = {}} = this.props;

    if (previous_results && previous_results.length > 0) {
      return previous_results[0];
    }

    return false;
  }

  getLastRunVideo() {
    const lastRun = this.getLastRun();

    if (lastRun) {
      return lastRun.video;
    }

    return false;
  }

  toggleFormExpanded(key, target) {
    this.setState({expandedTarget: target});
    if (this.props.toggleFormExpanded) {
      this.props.toggleFormExpanded(key);
      return;
    }

    this.setState({formExpanded: this.hasFormList() && !this.state.formExpanded});
  }

  componentDidMount() {
    this.scrollToTarget();
  }

  componentDidUpdate() {
    this.scrollToTarget();
  }
  
  scrollToTarget() {
    if (this.state.expandedTarget && this.state.formExpanded && window) {
      const id = `${this.props.runner.key}-${this.state.expandedTarget}`;
      document.getElementById(id).scrollIntoView({
        block: 'start'
      });
      const navOffset = isMobile ? -160 : -207;
      window.scrollBy(0, navOffset);
      this.setState({expandedTarget: null});
    }
  }

  render(){
    const {
      runner: {
        rideBetlinkIds,
        odds,
        saddleClothNo,
        drawNumber,
        silkFilename,
        headgear = [],
        raceHistoryStats = [],
        weightPenalty,
        horse,
        insights = [],
        horseName,
        horseLastRan,
        horseAge,
        weight,
        officialRating = '-',
        form,
        trainer,
        jockey,
        jockeyClaim,
        commentary,
        key,
        startingPriceAvailable,
        medication = []
      },
      eventRef: eventBetlinkId,
      showLastRun: showLastRunVideo,
      eachWay,
      suspended,
      fixture,
      embedded = false
    } = this.props;

    const {
      formExpanded
    } = this.state;

    const runnerHasForm = this.hasFormList();
    const lastRunVideo = this.getLastRunVideo();
    const lastRun = this.getLastRun();
    const hasLastRunVideo = !_.isEmpty(lastRunVideo);

    let betLinkProps;
    if(odds){
      const displayTime = localTimeShort(`${this.props.raceSummary.date}T${this.props.raceSummary.time}Z`);

      betLinkProps = {
        marketId: this.props.runner.marketId,
        eventId: eventBetlinkId,
        eventName: `${displayTime} ${this.props.raceSummary.course_name}`,
        eventCompetition: this.props.raceSummary.course_name, // only relevant for feature "integrated-betslip"
        dateTime: `${this.props.raceSummary.date} ${this.props.raceSummary.time}`,
        sport: "horseRacing",
        betId: rideBetlinkIds[0],
        betName: horseName,
        odds,
        eachWay, // only relevant for feature "integrated-betslip"
        suspended, // only relevant for feature "integrated-betslip"
        fixture, // only relevant for feature "integrated-betslip"
        startingPriceAvailable // only relevant for feature "integrated-betslip"
      };
    }

    return (
      <section id={`${this.props.runner.key}`} className="hr-racing-runner-wrapper">
        <div className="hr-racing-runner-key-info-container">
          <div className="hr-racing-runner-saddle-stall-info">
            <div className="row">
              <span className="hr-racing-runner-saddle-cloth-no">{saddleClothNo}</span>
            </div>
            <div className="row">
              <span className="hr-racing-runner-stall-no">{drawNumber}</span>
            </div>
          </div>
          <div className="hr-racing-runner-silks">
            <Silk filename={silkFilename}/>
          </div>
          <div className="hr-racing-runner-horse-info">
            <div className="row">
              <span className="hr-racing-runner-horse-name">
                <Link to={`/racing/profiles/horse/${horse.horse_reference.id}`} id={"horse-number-"+saddleClothNo}>{horseName}</Link>
                { headgear.length > 0 &&
                  <sup className="hr-racing-runner-horse-headgear">{formatHeadgear(headgear)}</sup>
                }
                <sup className="hr-racing-runner-horse-last-ran">{horseLastRan}</sup>
                { weightPenalty &&
                  <sup className="hr-racing-runner-horse-weight-penalty">(ex {weightPenalty})</sup>
                }
              </span>
            </div>
            <div className="row">
              <div className="hr-racing-runner-horse-sub-info">
                { horseAge && <span>{horseAge}</span> }
                { weight && <span>{weight}</span> }
                <span>{`OR: ${officialRating}`}</span>
                { raceHistoryStats.length > 0 && raceHistoryStats.map(({type}) =>
                  <span className="hr-racing-runner-race-history-stats" key={type}>{keepUpperCase(type)}</span>)
                }
                { medication.length > 0 && medication.map( type =>
                  <span className="hr-racing-runner-race-medication-stats" key={type}>{keepUpperCase(type)}</span>)
                }
              </div>
            </div>
          </div>
          <div className="hr-racing-runner-betting-odds" id={"horse-odds-"+saddleClothNo}>
            { !!betLinkProps &&
              <BetLink className='hr-racing-runner-betting-link sui-odds' {...betLinkProps}>{odds}</BetLink>
            }
          </div>
        </div>

        <div className="hr-racing-runner-form-history-container">
          <div className="hr-racing-runner-form-key-info">
            <Link className="hr-racing-runner-form-trainer" id={"trainer-number-"+saddleClothNo} to={`/racing/profiles/trainer/${trainer.business_reference.id}`}>T:&nbsp;<span>{trainer.name}</span></Link>
            <Link className="hr-racing-runner-form-jockey" to={`/racing/profiles/jockey/${jockey.person_reference.id}`}>
              J:&nbsp;
              <span className="hr-racing-runner-form-jockey-name" id={"jockey-number-"+saddleClothNo}>{jockey.name}</span>
              <span className="hr-racing-runner-form-jockey-claim">{` ${jockeyClaim}`}</span>
            </Link>
          </div>
        </div>        
        {
          embedded
          ? (showLastRunVideo && <div className="hr-racing-runner-form-watch-last-run" id={"watch-last-run-"+saddleClothNo}>
              <RaceVideoPlayer videos={lastRunVideo}/>
            </div>
          )
          : ((commentary) &&
            <div className="hr-racing-runner-form-watch-info-container">
              <p className="hr-racing-runner-form-watch-info-full">{commentary}</p>
              <HorseRacingInsightsList insights={insights} />
            </div>
          )
        }
        {runnerHasForm &&
        <div className="hr-racing-runner-form-history-container">
          <div className="hr-racing-runner-form-key-info">
            <button className="hr-racing-runner-show-form" onClick={()=>this.toggleFormExpanded(key, "form")} disabled={!runnerHasForm}>
              {runnerHasForm && <CaretIcon type="full" direction={formExpanded ? "up" : "down"}/>}
              <label className="hr-racing-runner-form-stat"><span>Form:</span>&nbsp;{form}</label>
            </button>
            {
              (hasLastRunVideo) && <span className="hr-racing-runner-embedded-last-run-button" id={"embedded-last-run-btn"+saddleClothNo} onClick={()=>this.toggleFormExpanded(key, "last-run")}><PlayIcon title="Watch last race" subText="Last Run"/></span>
            }
          </div>
          { formExpanded &&
            <div id={`${key}-form`}>
              <HorseRacingFormTable horse={horse} results={horse.previous_results} />
              <div className="hr-racing-runner-last-run-container" id={`${key}-last-run`}> 
                <HorseRacingLastRun lastRun={lastRun} />
              </div>              
            </div>
          }
        </div>}   
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingRacecardRunner.js